module.exports = "/assets/data/c7f155417485ba7ab2de41b228e3e4b3-ST5.data.json";